import { AccessDenied } from 'lib/components/AccessDenied'

export function ErrorAccessDenied(): JSX.Element {
    return <AccessDenied />
}
